exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/in-course-search.js-WebpackMultiOutput";